module.exports = __webpack_public_path__ + "img/ia.5445fc15.svg";